import React from 'react'
import qs from 'qs'
import classNames from 'classnames'
import { Popover } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import UploadIns from 'meinian-package/src/component/uploadIns'
import renderViewSettingModal from '../../../component/navUser/viewSettingModal'
import ImageSize from './imageSize'
import styles from './index.module.less'

export const VIEW_MODE = { IMAGE: 1, TEXT: 2, MULTI_GRAPH: 3 }

export const STYLE_RULES_KEY = 'mn:style:columnRulesType'
export const STYLE_TYPE_KEY = 'mn:style:viewMode'
export const STYLE_RULES_VALUE = '1'

export const StyleSwitchingView = ({
  className,
  style,
  onViewMode,
  viewMode,
  columnRulesType,
  onColumnRulesType,
  onClick
}) => {
  const content = (<div className={styles.styleSwitchingViewContent}>
    <div
      className={classNames('view-mode-item-wrap', 'fill-white-bg', { active: viewMode === VIEW_MODE.TEXT })}
      onClick={() => {
        onViewMode(VIEW_MODE.TEXT)
      }}
    >
      <div className="view-mode-item">
        <Icon type="m-tuwenmoshi" className="view-mode-item-icon" />
        <span>图文模式</span>
      </div>
    </div>
    <div
      className={classNames('view-mode-item-wrap', 'fill-white-bg', { active: viewMode === VIEW_MODE.MULTI_GRAPH })}
      onClick={() => {
        onViewMode(VIEW_MODE.MULTI_GRAPH)
      }}
    >
      <div className="view-mode-item">
        <Icon type="m-duotumoshi" className="view-mode-item-icon" />
        <span>多图模式</span>
      </div>
    </div>
    <div
      className={classNames('view-mode-item-wrap', 'fill-white-bg', { active: viewMode === VIEW_MODE.IMAGE })}
      onClick={() => {
        onViewMode(VIEW_MODE.IMAGE)
      }}
    >
      <div className="view-mode-item">
        <Icon type="m-chuntumoshi" className="view-mode-item-icon" />
        <span>纯图模式</span>
      </div>
    </div>
    {
      viewMode === VIEW_MODE.IMAGE && <div className="pureGraphSize">
        <ImageSize
          value={columnRulesType}
          onChange={(val) => {
            onColumnRulesType(val)
          }}
        />
      </div>
    }
    <div className="view-mode-setting-line" />
    <div
      className="view-mode-setting fill-white-bg"
      onClick={() => {
        renderViewSettingModal({})
      }}
    >设置</div>
  </div>)
  return <div className={classNames(styles.styleSwitchingView, className)} style={style}>
    <Popover
      placement="left"
      content={content}
      trigger="click"
      getPopupContainer={trigger => trigger}
      overlayClassName={styles['styleSwitchingViewText-popover']}
    >
      <div
        className="styleSwitchingViewText fill-white-bg"
        onClick={onClick}
      >视图切换</div>
    </Popover>
  </div>
}

export const UploadStyle = ({ className, style, onChange, onClick }) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  return <div
    onClick={() => {
      onClick?.()
      UploadIns.Show({
        inspirationId: query.inspirationId ? Number(query.inspirationId) : null,
        callback: () => {
          onChange()
        }
      })
    }}
    className={classNames(styles.uploadStyle, 'fill-white-bg', className)}
    style={style}
  >
    上传款式
  </div>
}
